import { UploadingDocumentState as State } from '@/interfaces/documents';
import { DocumentumService } from '@/services/documentum/documentum.service';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';

const defaultPlaceholder = 'Adjuntar Documento';
@Component({
  selector: 'app-attach-document[driverMdmid]',
  templateUrl: './attach-document.component.html',
  styleUrls: ['./attach-document.component.css'],
})
export class AttachDocumentComponent implements OnInit {
  state: State = {
    status: 'initial',
    description: '',
    fileUrl: '',
    fileName: '',
  };

  maxFileSizeMB = 5;

  @Input() requiredDocumentId: number | undefined;
  @Input() requirementId: number = 0;
  @Input() assetId: number = 0;
  @Input() driverMdmid: string = '';

  @Input() placeholder?: string = defaultPlaceholder;
  @Input() showErrors?: boolean = false;

  @Input() controlForm: FormControl = new FormControl({
    status: 'initial',
    description: '',
    fileUrl: '',
    fileName: '',
  });

  @Output() stateEmitter: EventEmitter<State> = new EventEmitter();

  realInputControlForm: FormControl = new FormControl();

  constructor(
    private cdr: ChangeDetectorRef,
    private documentumService: DocumentumService,
  ) {
  }

  ngOnInit(): void {
    const newState: Record<string, any> = {};
    if (this.placeholder !== defaultPlaceholder) {
      newState.fileName = this.placeholder;
    }
    const { status, description, fileUrl, fileName } = this.controlForm.value;
    if (status) newState.status = status;
    if (description) newState.description = description;
    if (status) newState.status = status;
    if (fileUrl) newState.fileUrl = fileUrl;
    if (fileName) newState.fileName = fileName;
    this.setState(newState);
  }

  setState(newStateKeys: Partial<State>): void {
    this.realInputControlForm.reset();
    this.state = {
      ...this.state,
      ...newStateKeys,
    };
    this.stateEmitter.emit(this.state);
    this.controlForm.patchValue(this.state);
    this.cdr.detectChanges();
  }

  onFileSelected(event: any): void {
    const previousState = JSON.parse(JSON.stringify(this.state));
    const file: File = event.target.files[0];
    if (file) {
      this.setState({
        status: 'uploading',
        description: '',
        // fileName: '',
      });
      const oldFileName = this.state.fileName;
      const fileName = file.name;
      if (!this.isValidFileExtension(fileName)) {
        this.setState({
          ...this.state,
          status: 'error',
          description: 'Debe adjuntar un archivo con formato PDF.',
        });
        // eslint-disable-next-line no-param-reassign
        // event.target.files[0] = null;
        of({}).pipe(delay(5000)).subscribe({
          next: () => {
            this.setState(previousState);
          },
        });
        return;
      }
      if (!this.isValidFileSize(file.size)) {
        this.setState({
          ...this.state,
          status: 'error',
          description: `El peso máximo del documento no debe superar los ${this.maxFileSizeMB} MB.`,
        });
        setTimeout(() => {
          this.setState(previousState);
        }, 7000);
        return;
      }

      this.documentumService.uploadFile({
        fileToUpload: file,
        name: fileName,
        mdmid: this.driverMdmid,
        requirementId: this.requirementId,
        documentId: this.requiredDocumentId as number,
        assetId: this.assetId,
      }).subscribe({
        next: (id) => {
          this.setState({
            status: 'uploaded',
            description: '',
            fileUrl: `${id}`,
            fileName,
          });
        },
        error: () => {
          this.setState({
            status: 'error',
            description: 'Error al subir el archivo',
            fileName: oldFileName,
          });

          setTimeout(() => {
            this.setState(previousState);
          }, 7000);
        },
      });
    }
  }

  isValidFileExtension(fileName: string): boolean {
    const aceptedExtension = [
      'pdf',
      // 'png',
      // 'jpg',
    ];
    const fileExtension = fileName.split('.').pop();
    if (fileExtension) {
      return aceptedExtension.includes(fileExtension.toLocaleLowerCase());
    }
    return false;
  }

  isValidFileSize(fileSize: number): boolean {
    const fileSizeMb = fileSize / 1024 / 1024;
    return !(fileSizeMb > this.maxFileSizeMB);
  }
}
